// extracted by mini-css-extract-plugin
module.exports = {"container":"TasksListHeader_container__5EUWS","add":"TasksListHeader_add__6ogVe","name":"TasksListHeader_name__3lRMz","addVisible":"TasksListHeader_addVisible__s59tW"};